/** @jsx jsx */
import { jsx } from 'theme-ui';

const UnbulletedList = (props) => (
  <ul
    sx={{
      listStyleType: 'none',
      m: 0,
      p: 0,
    }}
    {...props}
  />
);

export default UnbulletedList;
